import React, { useEffect, useState } from 'react';

// Styles & Assets
import styles from './PreconfigData.module.css';
import { AiOutlineCloseCircle } from 'react-icons/ai';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/useHttp';

// Components
import Input from '../../UI/Input/Input';
import MultiSelectPathologies from '../MultiSelectPathologies/MultiSelectPathologies';
import MultiSelectProfiles from '../MultiSelectProfiles/MultiSelectProfiles';

// Interfaces
import { Pathology } from '../../../interfaces/Preconfigurations';
import type { PreconfigDataDispatch } from '../../../hooks/preconfig-hooks';

interface Props {
    newPreconfig: boolean;
    name: string;
    selectedPathologiesIDs: number[];
    selectedPreconfigIDs: number[];
    dispatchPreconfig: React.Dispatch<PreconfigDataDispatch>;
}

const PreconfigData: React.FC<Props> = ({
    newPreconfig,
    selectedPathologiesIDs,
    selectedPreconfigIDs,
    dispatchPreconfig,
    name,
}) => {
    const { t } = useTranslation();

    const { sendRequest } = useHttp<Pathology[]>();

    const [pathologies, setPathologies] = useState<Pathology[]>([]);

    useEffect(() => {
        sendRequest(
            {
                url: getEnvironmentApiUrl() + 'pathology/all',
                method: 'POST',
                body: { params: {}, filter: {} },
            },
            (data) => setPathologies(data)
        );
    }, [sendRequest]);

    const handleChangeName = (evt: React.ChangeEvent<HTMLInputElement>) => {
        dispatchPreconfig({
            type: 'CHANGE_NAME',
            payload: evt.target.value,
        });
    };

    const handleDeletePathology = (id: number) => {
        dispatchPreconfig({
            type: 'REMOVE_PATHOLOGY',
            payload: id,
        });
    };

    return (
        <>
            <div className={styles.titleContainer}>
                <h1 className={`title ${styles.title}`}>
                    {newPreconfig ? t('new_preconfig') : name}
                </h1>

                <div className={styles.pathologiesLinked}>
                    {selectedPathologiesIDs.map(
                        (pathologyID) =>
                            pathologyID !== -1 && (
                                <div className={styles.pathologyContainer} key={pathologyID}>
                                    <span>{pathologies.find((p) => p.id === pathologyID)?.name ?? ''}</span>
                                    <button onClick={() => handleDeletePathology(pathologyID)}>
                                        <AiOutlineCloseCircle />
                                    </button>
                                </div>
                            )
                    )}
                </div>
            </div>

            <div className={styles.inputs}>
                <Input
                    label={t('enter_name')}
                    onChange={handleChangeName}
                    defaultValue={name ?? ''}
                />

                <MultiSelectPathologies
                    pathologies={pathologies}
                    selectedPathologiesIDs={selectedPathologiesIDs}
                    dispatchPreconfig={dispatchPreconfig}
                />

                <MultiSelectProfiles
                    selectedPreconfigIDs={selectedPreconfigIDs}
                    dispatchPreconfig={dispatchPreconfig}
                />
            </div>
        </>
    );
};

export default PreconfigData;